"use strict";

import setupSwiper from "../utils/setupSwiper";

document.addEventListener("DOMContentLoaded", () => {
  // LATEST NEWS
  let latestNewsBlocks = document.querySelectorAll(
    ".component__latest-news .swiper"
  );
  latestNewsBlocks.forEach((block) => {
    let thisID = block.id;
    let thisSwiper = setupSwiper(thisID, {
      spaceBetween: 16,
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        991: {
          slidesPerView: 3,
        },
      },
      pagination: {
        el: "#" + thisID + "-pagination",
        clickable: true,
      },
    });
  });

  // LATEST NEWS
  let latestNewsV2Blocks = document.querySelectorAll(
    ".component__latest-news-v2 .swiper"
  );
  latestNewsV2Blocks.forEach((block) => {
    let thisID = block.id;
    let thisSwiper = setupSwiper(thisID, {
      spaceBetween: 16,
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        991: {
          slidesPerView: 3,
        },
      },
      pagination: {
        el: "#" + thisID + "-pagination",
        clickable: true,
      },
    });
  });

  // LATEST PROJECTS
  let latestProjects = document.querySelectorAll(
    ".component__latest-projects.module__default .swiper"
  );
  latestProjects.forEach((block) => {
    let thisID = block.id;
    let thisSwiper = setupSwiper(thisID, {
      spaceBetween: 16,
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        991: {
          slidesPerView: 3,
        },
      },
      pagination: {
        el: "#" + thisID + "-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: "#" + thisID + "-next",
        prevEl: "#" + thisID + "-prev",
      },
    });
  });

  // LATEST NEWS
  let mediaGalleryBlocks = document.querySelectorAll(
    ".component__media .media__gallery .swiper"
  );
  mediaGalleryBlocks.forEach((block) => {
    let thisID = block.id;
    let thisSwiper = setupSwiper(thisID, {
      spaceBetween: 16,
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
      },
      navigation: {
        nextEl: "#" + thisID + "-next",
        prevEl: "#" + thisID + "-prev",
      },
      pagination: {
        el: "#" + thisID + "-pagination",
        clickable: true,
      },
    });
  });

  // STAT CARDS
  let statCardBlocks = document.querySelectorAll(
    ".component__stat-cards .swiper"
  );
  statCardBlocks.forEach((block) => {
    let thisID = block.id;
    const breakpoint = window.matchMedia("(max-width: 767px)");
    let thisSwiper;

    const breakpointChanged = () => {
      // console.log(breakpoint.matches);
      if (breakpoint.matches === true) {
        thisSwiper !== undefined && thisSwiper.destroy(true, true);
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };

    const enableSwiper = () => {
      thisSwiper = setupSwiper(thisID, {
        spaceBetween: 16,
        slidesPerView: 3,
        pagination: {
          el: "#" + thisID + "-pagination",
        },
      });
    };

    breakpoint.addEventListener("change", breakpointChanged);
    breakpointChanged();
  });

  // PEOPLE
  let peopleBlocks = document.querySelectorAll(".component__people .swiper");
  peopleBlocks.forEach((block) => {
    let thisID = block.id;
    const breakpoint = window.matchMedia("(max-width: 767px)");
    let thisSwiper;

    const breakpointChanged = () => {
      // console.log(breakpoint.matches);
      if (breakpoint.matches === true) {
        thisSwiper !== undefined && thisSwiper.destroy(true, true);
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };

    const enableSwiper = () => {
      thisSwiper = setupSwiper(thisID, {
        spaceBetween: 16,
        slidesPerView: 2,
        breakpoints: {
          992: {
            slidesPerView: 3,
          },
        },
        navigation: {
          nextEl: "#" + thisID + "-next",
          prevEl: "#" + thisID + "-prev",
        },
        pagination: {
          el: "#" + thisID + "-pagination",
        },
      });
    };

    breakpoint.addEventListener("change", breakpointChanged);
    breakpointChanged();
  });

  // CAREERS
  let careerBlocks = document.querySelectorAll(".component__careers .swiper");
  careerBlocks.forEach((block) => {
    let thisID = block.id;
    let thisSwiper = setupSwiper(thisID, {
      spaceBetween: 16,
      slidesPerView: 1,
      breakpoints: {
        650: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
      navigation: {
        nextEl: "#" + thisID + "-next",
        prevEl: "#" + thisID + "-prev",
      },
      pagination: {
        el: "#" + thisID + "-pagination",
        clickable: true,
      },
    });
  });

  // DASHBOARD PROJECTS
  let dashboardProjects = document.querySelectorAll(
    ".component__dashboard-project-list .swiper"
  );
  dashboardProjects.forEach((block) => {
    let thisID = block.id;
    let thisSwiper = setupSwiper(thisID, {
      spaceBetween: 16,
      slidesPerView: 1,
      breakpoints: {
        650: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
      navigation: {
        nextEl: "#" + thisID + "-next",
        prevEl: "#" + thisID + "-prev",
      },
      pagination: {
        el: "#" + thisID + "-pagination",
        clickable: true,
      },
    });
  });
});
